module.exports = __webpack_public_path__ + "img/logo-light.41bfd4b9.svg";